import { useState, useEffect } from "react";
import useLenis from "@/hooks/useLenis";
import Header from "@/components/wedding/Header";
import Hero from "@/components/wedding/Hero";
import Marquee from "@/components/wedding/Marquee";
import Location from "@/components/wedding/Location";
import Gallery from "@/components/wedding/Gallery";
import Details from "@/components/wedding/Details";
import Hotel from "@/components/wedding/Hotel";
import Rsvp from "@/components/wedding/Rsvp";
import Footer from "@/components/wedding/Footer";
import VideoModal from "@/components/wedding/VideoModal";
import { useContent } from "@/context/ContentContext";

export default function Home() {
  const wedding = useContent();
  const [videoOpen, setVideoOpen] = useState(false);
  useLenis();

  useEffect(() => {
    document.title = "Boda de Caro y Roberto";
  }, []);

  return (
    <div className="bg-paper">
      <Header />
      <Hero onOpenVideo={() => setVideoOpen(true)} />
      <Marquee text={`${wedding.bride} & ${wedding.groom} — ${wedding.dateLabel}`} />
      <Location />
      <Gallery />
      <Details />
      <Hotel />
      <Marquee text="Te elijo hoy y para siempre" dark />
      <Rsvp />
      <Footer />
      <VideoModal open={videoOpen} onClose={() => setVideoOpen(false)} />
    </div>
  );
}
